import React from 'react'
import styled from 'styled-components'
import PageWrapper from '../PageWrapper'
import MarkdownParser from '../MarkdownParser'
const url = process.env.REACT_APP_PW_API_URL;

const Terminos2025 = () => {
  return (
    <>
      <PageWrapper>
        <Panel className="responsive-sm flex-row">
          <MarkdownParser url={`${url}/files/terminos.md?v=${Date.now()}`} />
        </Panel>
      </PageWrapper>
    </>
  );
};


const Panel = styled.div`
  background: #000;
  margin: 5rem auto;
  max-width: 1200px;
  padding: 3rem;
  border-radius: 1rem;
`

export default Terminos2025